<template>
  <el-dropdown
    trigger="click"
    placement="bottom"
    :hide-on-click="false"
    class="project-dropdown"
    :class="{ 'is-active': projectVisible }"
    @visible-change="handleProjectVisible"
  >
    <div class="project" data-qa="project-dropdown">
      <div class="project-icon">
        <img v-if="project && project.icon" :src="project.icon" />
        <img v-else src="@/img/icon/app-ico.png" />
      </div>
      <div class="project-header">
        <span v-if="project">{{ project.name }}</span>
        <span v-else>{{ $t('TopToolbar_ChooseProject') }}</span>
      </div>
      <i
        v-if="!projectVisible"
        class="el-icon-folder-opened el-icon--right dropdown-icon"
      />
      <i
        v-if="projectVisible"
        class="el-icon-close el-icon--right dropdown-icon"
      />
    </div>
    <el-dropdown-menu
      slot="dropdown"
      :arrow-offset="60"
      class="project-dropdown-menu"
      data-qa="project-dropdown-menu"
    >
      <el-dropdown-item class="project-search">
        <div>
          <el-input
            ref="projectSearch"
            v-model="projectFilter"
            :placeholder="$t('TopToolbar_Project_SearchPlaceholder')"
            class="project-search-box"
            data-qa="project-search-box"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
      </el-dropdown-item>
      <div class="project-wrapper">
        <a
          v-for="projectItem in projects"
          :href="getProjectUrl(projectItem.id)"
        >
          <el-dropdown-item class="dropdown-project">
            <img v-if="projectItem.icon" :src="projectItem.icon" />
            <img v-else src="@/img/icon/app-ico.png" />
            <div v-if="uniqueCompanies && uniqueProviders">
              <span>{{ projectItem.name }}</span>
            </div>
            <div
              v-else-if="uniqueProviders && !uniqueCompanies"
              class="project-item"
            >
              <span>{{ projectItem.name }}</span>
              <span>{{ projectItem.company.name }}</span>
            </div>
            <div v-else class="project-item">
              <span>{{ projectItem.name }}</span>
              <span>
                {{
                  `${projectItem.provider.name} > ${projectItem.company.name}`
                }}
              </span>
            </div>
            <icon glyph="navdropdown-arrow" size="20" />
          </el-dropdown-item>
        </a>
      </div>
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script>
import { debounce } from 'lodash'

export default {
  name: 'TopToolbarProjectDropdown',

  data() {
    return {
      projectFilter: '',
      projectVisible: false
    }
  },

  computed: {
    uniqueCompanies() {
      let projects = this.$store.state.app.projects
      let unique = projects.reduce((acc, curr) => {
        if (!acc.includes(curr.company.name)) {
          acc.push(curr.company.name)
        }

        return acc
      }, [])
      return unique.length <= 1
    },

    uniqueProviders() {
      let projects = this.$store.state.app.projects
      let unique = projects.reduce((acc, curr) => {
        if (!acc.includes(curr.provider.name)) {
          acc.push(curr.provider.name)
        }

        return acc
      }, [])
      return unique.length <= 1
    },

    project() {
      return this.$store.state.app.project
    },

    projects() {
      return this.$store.state.app.projects
    }
  },

  watch: {
    projectFilter(value) {
      this.fetchProjects(value)
    }
  },

  methods: {
    handleProjectVisible(val) {
      if (
        this.$store.state.app.user &&
        this.$can('viewProject') &&
        !this.$isSuperAdmin()
      ) {
        this.$store.dispatch('fetchProjects')
      }
      if (val) {
        this.$nextTick(() => this.$refs.projectSearch.$el.children[0].focus())
      }
      this.projectVisible = val
    },

    fetchProjects: debounce(function(value) {
      this.$store.dispatch('fetchProjects', value)
    }, 500),

    getProjectUrl(projectId) {
      if (this.$can('viewProjectAnalytics')) {
        return `/analytics/analytics/index?project_id=${projectId}`
      }
      if (this.$can('Profile::Read')) {
        return `/profiles?project_id=${projectId}`
      }
      return `/push/campaign-template/index?project_id=${projectId}`
    }
  }
}
</script>
<style scoped>
.project {
  display: flex;
  height: 64px;
  color: #fff;
  margin-left: 1px;
}

.project .project-icon {
  margin: auto 16px auto 13px;
  width: 32px;
  height: 32px;
}

.project .dropdown-icon {
  right: 0;
  font-size: 20px;
  margin: auto auto;
}

.project .project-icon img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.project .project-header {
  width: 166px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  margin: auto 5px;
}

.project-dropdown {
  width: 306px;
  border-right: 1px solid #176ca0;
  background: #1d87c8;
  cursor: pointer;
  box-sizing: border-box;
}

.project-dropdown:hover {
  background: #0775b6;
}

.project-dropdown.is-active {
  background: #0775b6;
}

.project-dropdown-menu {
  top: 55px !important;
  left: 210px !important;
  margin-top: 2px;
  width: 320px;
  border-radius: 4px !important;
  padding: 0;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

.project-wrapper {
  max-height: 50vh;
  overflow-y: scroll;
}

>>> .icon svg {
  color: #1d87c8;
}

.project-dropdown-menu > .project-search {
  background-color: #fff;
  padding: 8px 8px 0 8px;
  cursor: unset;
  height: 48px;
}

>>> .project-search-box input {
  border: 1px solid #dbdee7;
  box-sizing: border-box;
  border-radius: 4px;
  height: 36px;
}

.project-dropdown-menu > .project-search:hover,
.project-dropdown-menu > .project-search:focus {
  color: unset;
  background-color: #fff;
}

.project-dropdown-menu .dropdown-project:hover {
  color: unset;
  background-color: #fff;
}

.project-dropdown-menu .dropdown-project {
  display: flex;
  justify-content: space-between;
  padding: 12px 15px;
}

.project-dropdown-menu .dropdown-project img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  vertical-align: middle;
  margin: auto 0;
}

.project-dropdown-menu .dropdown-project > .project-item {
  height: 40px;
}

.project-dropdown-menu .dropdown-project > div {
  height: 22px;
  line-height: 22px;
  width: 236px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: auto 0;
}

.project-dropdown-menu .dropdown-project .project-item {
  display: flex;
  flex-direction: column;
}

.project-dropdown-menu .dropdown-project span {
  line-height: 15px;
  height: 20px;
  white-space: nowrap;
  color: #000;
  text-overflow: ellipsis;
  margin-left: 10px;
  font-size: 14px;
}

.project-dropdown-menu .dropdown-project .project-item span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.project-dropdown-menu .dropdown-project .project-item span:last-child {
  font-size: 13px;
  color: #98999a;
}

.project-dropdown-menu .dropdown-project:hover {
  color: unset;
  background-color: #e6f3fb;
}
</style>



// WEBPACK FOOTER //
// src/common/components/navigation/TopToolbarProjectDropdown.vue